import React, { Component } from 'react';
import Tibbit_base from '@appblocks/frontend/client/Components/TPP/Tibbit_base';

export default class Tibbit_hybrid_narrow extends Tibbit_base {
    constructor(props: any) {
        super(props);
        this.width = 148;
        this.height = 48.63;
    }

    render() {
        return (
            <g id="hybrid_narrow" {...this.props} className="tibbit">
                <rect className="draggable" x="-46.05" y="0" width="148" height="48.63" />
                <g transform="translate(-46.05, -2)">
                    <rect className="pcbColor" x="40.525" y="13.132" width="5.525" height="26.892" />

                    <path id="color" className={`moduleColor_${this.props.category}`} d="M147.93,51.023H46.05V2.131h101.88V51.023z" />
                    <polygon className="moduleColor_connector" points="9.877,3.215 2.258,3.215 2.258,2.086 0,2.086 0,51.024 2.258,51.024 2.258,49.895 9.877,49.895 &#10;&#9;9.877,51.024 44.634,51.024 44.634,46.071 40.663,46.071 40.663,6.78 44.634,6.78 44.634,2.086 9.877,2.086 " />

                    <path className="recess" d="M55.779,47.633H46.05V5.522h9.729v4.123h-5.27v2.819h5.27v4.938h-5.27v2.82h5.27v4.949h-5.27v2.819h5.27v4.929h-5.27v2.819&#10;&#9;&#9;h5.27v4.863h-5.27v2.819h5.27V47.633z M138.201,5.522v4.123h5.26v2.819h-5.26v4.938h5.26v2.82h-5.26v4.939h5.26v2.819h-5.26v4.938&#10;&#9;&#9;h5.26v2.819h-5.26v4.865h5.26v2.818h-5.26v4.21h5.26h4.469V5.522H138.201z" />

                    <rect className="recess" x="2.258" y="3.215" width="7.62" height="46.596" />

                    <polygon transform="rotate(-90 25.5115 25.5115)" className="labelColor" points="3.399,133.922 45.506,133.932 45.515,68.702 37.066,60.042 3.39,60.05 " />

                    <g id="label">
                        <text transform="matrix(1 0 0 1 66.9113 17)" className="label" id="num">{this.props.num}</text>
                        <text transform="matrix(1 0 0 1 67.2663 28.2717)" className="desc" id="desc">
                            {this.renderDescriptions()}
                        </text>
                    </g>
                    <g id="lines">
                        {this.renderLines()}
                    </g>

                    <polygon className="tibbitStroke" points="46.05,2.131 46.05,13.132 40.663,13.132 40.663,6.78 44.634,6.78 44.634,2.086 9.877,2.086 &#10;&#9;&#9;9.877,3.215 2.258,3.215 2.258,2.086 0,2.086 0,51.024 2.258,51.024 2.258,49.895 9.877,49.895 9.877,51.024 44.634,51.024 &#10;&#9;&#9;44.634,46.071 40.663,46.071 40.663,40.024 46.05,40.024 46.05,51.023 147.93,51.023 147.93,2.131 " />
                </g>
                {this.renderWiring()}
            </g>
        );
    }
}
